import React from 'react';
import { useGLTF } from '@react-three/drei';
import { GroupProps } from '@react-three/fiber';
import codLiverOilGltf from '../../../../../../static/gltf/Cod_liver_oil/Cod_liver_oil_threejs-opt.glb';

const MODEL_URL = codLiverOilGltf;

function CodLiverOil(props: GroupProps) {
    const { nodes } = useGLTF(MODEL_URL, true) as any;

    return (
        <group {...props} dispose={null}>
            <mesh
                geometry={nodes.Cod_liver_oil_1.geometry}
                material={nodes.Cod_liver_oil_1.material}
                rotation={[Math.PI / 2, 0, 0]}
            />
        </group>
    );
}

export default CodLiverOil;
